module.exports = __webpack_public_path__ + "static/img/join2.0ee60a1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test/join2.jpeg
// module id = hKS3
// module chunks = 1